import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// ============================================================================
// FOOTER COMPONENT
// ============================================================================

const Footer = () => {
  const { t } = useTranslation();
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 1, sm: 2 },
        px: { xs: 2, sm: 3 },
        bgcolor: "var(--bg-card)",
        borderTop: "1px solid var(--border-color)",
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: {
            xs: "100%",
            md: "calc(100% - 240px)",
          },
          mx: "auto",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: { xs: "0.7rem", sm: "0.875rem" },
            lineHeight: 1.4,
            color: "var(--text-secondary)",
          }}
        >
          © {new Date().getFullYear()} HDMS CONSULTING. {t("footer.allRightsReserved")}
          {t("footer.authorizedUse")}{" "}
          <strong>ENERGEST - ENGENHARIA E SISTEMAS DE ENERGIA, S.A.</strong>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;